/**
 * StudentWithParentManagement Repository
 * 학생-학부모 연결 관리 API 호출
 */
import { API_BASE_URL } from '../../../config/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

/**
 * 학부모 초대 요청 타입
 */
export interface ParentInviteRequest {
  phone?: string; // 선택사항: 없으면 등록된 parent_phone_1 사용
  parent_number?: 1 | 2; // 선택사항: 1 (기본값) 또는 2
  relationship?: string;
}

/**
 * 학부모 초대 응답 타입
 */
export interface ParentInviteResponse {
  inviteUrl: string;
  token: string;
  expiresAt: string;
  studentName: string;
  phone: string;
}

export class StudentWithParentManagementRepository {
  /**
   * 학부모 초대 링크 생성
   *
   * @param studentId 학생 ID
   * @param request 초대 요청 (전화번호, 관계)
   * @returns 초대 링크 정보
   */
  async createParentInvite(
    studentId: string,
    request: ParentInviteRequest
  ): Promise<ParentInviteResponse> {
    const response = await fetch(
      `${API_BASE_URL}/api/v1/owner/students/${studentId}/invite-parent`,
      {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(request),
      }
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || '초대 링크 생성에 실패했습니다');
    }

    return await response.json();
  }
}

export const studentWithParentManagementRepository = new StudentWithParentManagementRepository();
